import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBook = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M20.62 4.22a1 1 0 00-.84-.2L12 5.77 4.22 4A1 1 0 003 5v12.2a1 1 0 00.78 1l8 1.8h.44l8-1.8a1 1 0 00.78-1V5a1 1 0 00-.38-.78zM5 6.25l6 1.35v10.15L5 16.4V6.25zM19 16.4l-6 1.35V7.6l6-1.35V16.4z",
			fillRule: "nonzero"
		})
	})
});
export { SvgBook as ReactComponent };
